import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Color from '../../../enums/color';
import { NavLink } from 'react-router-dom';
import useAccessPolicy from '../../../hooks/useAccessPolicy';
import ContentHandler from '../../shared/ContentHandler';
const StyledNavigationLink = styled(NavLink) `
  position: relative;
  background: ${Color.ElectricBlue};
  padding: 10px 0 10px 32px;
  border: none;
  display: flex;
  align-items: center;
  color: ${Color.Grey254};
  transition: all 0.3s ease-in-out;

  &:hover:not(.active) {
    color: ${Color.Grey223};
  }

  &.active {
    color: ${Color.Grey254};
    background: ${Color.OceanBlue};
    padding-left: 36px;
  }

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    content: '';
    height: 100%;
    width: 8px;
    background: transparent;
    transition: all 0.07s ease-in-out;
  }

  &.active::before, :hover::before {
    background: ${Color.White};
  }

  > span {
    margin-left: 8px;
    font-size: 14px;
    font-family: Roboto Condensed;
    line-height: normal;
  }
`;
const NavigationLink = ({ to, icon, title, automationId, policy }) => {
    const { t: translate } = useTranslation();
    const hasAccess = useAccessPolicy(policy);
    return (<ContentHandler shouldDisplayContent={hasAccess}>
      <StyledNavigationLink to={to} data-automation-id={automationId}>
        {icon}
        <span>{translate(title)}</span>
      </StyledNavigationLink>
    </ContentHandler>);
};
export default NavigationLink;
